module.exports = __webpack_public_path__ + "static/media/Sare Band.efb04a90.png";